import { LOADING, LOADING_ERROR, LOADING_SUCCESS } from './actionTypes'
import union from 'lodash/union'
import without from 'lodash/without'
import split from 'lodash/split'
import first from 'lodash/first'

const initialState = []

const handleAdd = (state, { component }) => union(state, [component])
const handleRemove = (state, { component }) => without(state, component)

export default (state = initialState, action) => {
    const { type, payload } = action

    const typePrefix = first(split(type, '/'))

    switch (typePrefix) {
        case LOADING:
            return handleAdd(state, payload)
        case LOADING_SUCCESS:
        case LOADING_ERROR:
            return handleRemove(state, payload)
        default:
            return state
    }
}
